export const COUNTRY_INFO_WIDTH = [10, 42, 20, 20, 5]; // margin right

export const COUNTRY_INFO_HEADER_COLUMNS = [
  { text: '№', width: COUNTRY_INFO_WIDTH[0] },
  { text: 'Город', width: COUNTRY_INFO_WIDTH[1] },
  { text: 'Lat', width: COUNTRY_INFO_WIDTH[2] },
  { text: 'Lon', width: COUNTRY_INFO_WIDTH[3] },
  { text: '', width: COUNTRY_INFO_WIDTH[4] },
];

export const DELETING_MODAL_STATES = {
  country: 'country',
  city: 'city',
};
